module.exports = __webpack_public_path__ + "img/fab icon.bc6ab632.svg";